<template>
    <div>
        <vx-card id="groupDiv" class="vs-con-loading__container xl:w-1/3 lg:w-1/2 w-full">
            <p class="mt-6">{{ $t('GroupName') }}</p>
            <vs-input class="w-full" v-model="access_group.name"/>
            <p class="mt-6">{{ $t('GroupType') }}</p>
            <vs-select autocomplete class="w-full" v-model="access_group.group_type">
                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in groupTypes" />
            </vs-select>
            <vs-divider/>
            <h4 class="mb-6">{{$t('AllowedTerminals')}}</h4>
            <vs-checkbox class="mt-3" v-model="access_group.allowed_terminals" :vs-value="terminal.id" :key="terminal.id" v-for="terminal in terminals">
                {{ terminal.name }}</vs-checkbox>

            <vs-divider/>
            <vs-button style="float: left" color="warning" icon-pack="feather" icon="icon-save" class="mb-3 mr-3" @click="saveAccessGroup">{{ $t('Save') }}</vs-button>
            <vs-button style="float: left" color="danger" icon-pack="feather" icon="icon-save" class="mb-3" @click="removeAccessGroup">{{ $t('Remove') }}</vs-button>

        </vx-card>

    </div>
</template>
<script>
    export default {

        data() {
            return {

                terminals: [],

                access_group: {

                    name: '',
                    group_type: 0,
                    number_of_users: 0,
                    number_of_terminals: 0,
                    allowed_terminals: []
                },

                groupTypes: [
                    {
                        id: 0,
                        name: this.$t('UnlimitedAccess')
                    },
                    {
                        id: 1,
                        name: this.$t('TicketRequired')
                    }
                ]
            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#groupDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get(`/api/management/v1/client_user_access_group/${this.$route.params.id}`)
                loadPromise.then(function(response) {
                    thisIns.access_group = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const terminalsPromise = this.$http.get('/api/management/v1/access_terminal/')
                terminalsPromise.then(function(response) {
                    thisIns.terminals = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([loadPromise, terminalsPromise]).finally(function() {
                    thisIns.$vs.loading.close('#groupDiv > .con-vs-loading')
                })
            },
            saveAccessGroup() {
                this.$vs.loading({
                    container: '#groupDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const addPromise = this.$http.put(`/api/management/v1/client_user_access_group/${this.$route.params.id}`, {
                    name: this.access_group.name,
                    group_type: Number(this.access_group.group_type),
                    allowed_terminals: this.access_group.allowed_terminals
                })

                addPromise.then(function() {
                    thisIns.$printSuccess(thisIns.$t('AccessGroupSaved'))
                    thisIns.loadData()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#groupDiv > .con-vs-loading')
                })
            },
            removeAccessGroup() {
                this.$vs.loading({
                    container: '#groupDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const removePromise = this.$http.delete(`/api/management/v1/client_user_access_group/${this.$route.params.id}`)

                removePromise.then(function() {
                    thisIns.$printSuccess(thisIns.$t('AccessGroupRemoved'))
                    thisIns.$nextTick(() => {
                        thisIns.$router.push('/access_groups')
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#groupDiv > .con-vs-loading')
                })
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>
